import { MessageSquare, CalendarCheck2, FileText } from "lucide-react";

const STEPS = [
  {
    n: "01",
    icon: MessageSquare,
    title: "Anfrage stellen",
    desc: "Über unser Formular in 4 Schritten geben Sie uns Ihren Wunschtermin für eine unverbindliche und kostenlose Erstbesichtigung an.",
  },
  {
    n: "02",
    icon: CalendarCheck2,
    title: "Kostenlose Besichtigung",
    desc: "Wir schauen uns Ihr Grundstück persönlich an – unverbindlich und kostenfrei.",
  },
  {
    n: "03",
    icon: FileText,
    title: "Angebot erhalten",
    desc: "Persönlich, transparent, mit fairem Preis – zugeschnitten auf Ihr Grundstück.",
  },
];

export default function Process() {
  return (
    <section id="ablauf" className="py-24 bg-[#FAFAF5]">
      <div className="max-w-6xl mx-auto px-6">
        <div className="max-w-2xl mb-16">
          <div className="text-sm font-medium text-[#6B7F3E] uppercase tracking-wider mb-3">
            So funktioniert's
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold text-[#1A201A] tracking-tight">
            In drei Schritten<br />zum gepflegten Grundstück.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-10 relative">
          {/* connector line on desktop */}
          <div className="hidden md:block absolute top-[52px] left-[12%] right-[12%] h-px bg-gradient-to-r from-transparent via-[#C4CFB1] to-transparent" />
          {STEPS.map((s, idx) => {
            const Icon = s.icon;
            return (
              <div
                key={s.n}
                data-testid={`process-step-${idx + 1}`}
                className={`bg-white rounded-2xl border border-[#E5E7EB] p-8 relative fade-slide-${idx + 1}`}
              >
                <div className="w-14 h-14 rounded-2xl bg-[#E8ECE1] flex items-center justify-center mb-5 relative z-10">
                  <Icon className="w-6 h-6 text-[#6B7F3E]" strokeWidth={1.5} />
                </div>
                <div className="text-xs font-mono text-[#6B7F3E] mb-2">{s.n}</div>
                <h3 className="font-display text-xl font-medium text-[#1A201A] mb-2">{s.title}</h3>
                <p className="text-[#5C6B5D] text-sm leading-relaxed">{s.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
